import { deviceOptions, variantSchema } from "@redotech/redo-model/signup-form";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const createSignupFormSplit = {
  name: "createSignupFormSplit" as const,
  input: z.object({
    teamId: zExt.objectId(),
    name: z.string().min(1, "Test name is required"),
    deviceTarget: createEnum(deviceOptions),
    variants: z.array(variantSchema).min(2, "At least 2 variants required"),
  }),
  output: z.object({ splitId: zExt.objectId() }),
};
